module.exports = __webpack_public_path__ + "static/media/cover.9199de59.png";